module.exports = __webpack_public_path__ + "static/media/DeniedAccessIcon.475bee63.svg";